module.exports = __webpack_public_path__ + "static/media/aquagym-group-lesson.898e0487.jpg";